import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './Playlist.css';
import React from 'react';
import { ReactComponent as ChevronDown } from '../../resources/icons/chevron-down.svg';
import { ReactComponent as IconPlayLarge } from '../../resources/icons/IconPlayLarge.svg';
import { get } from '../../utils';
import RouterLink from '../atoms/RouterLink';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
export var toHHMMSS = function toHHMMSS(time) {
  var sec_num = parseInt(time, 10); // don't forget the second param
  var hours = Math.floor(sec_num / 3600);
  var hour;
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;
  if (hours < 10) {
    hour = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return (hours ? hour + ':' : '') + minutes + ':' + seconds;
};
var PlaylistList = function PlaylistList(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? {} : _ref$items,
    rtl = _ref.rtl;
  var episode = items.episode || [];
  return /*#__PURE__*/React.createElement("div", {
    className: 'playlist__list-wrapper'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'playlist--wrapper'
  }, /*#__PURE__*/React.createElement("ul", {
    className: "playlist__list ".concat(episode.length > 4 ? 'scroll' : '')
  }, episode.map(function (v, i) {
    var title = get(v, 'title.jss.value');
    var fallbackImage = get(v, 'fallbackImage.jss.value.src');
    var Duration = get(v, 'video.jss.fields.Duration.value');
    return /*#__PURE__*/React.createElement("li", {
      className: 'playlist__list-item',
      key: i
    }, /*#__PURE__*/React.createElement(RouterLink, {
      openInSameTab: true,
      href: v.url + '?play=true',
      className: "video ".concat(v.timestamp ? v.timestamp / (Duration / 1000) * 100 > 90 ? 'completed' : '' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: 'video__image-wrapper'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'video__image'
    }, /*#__PURE__*/React.createElement("img", {
      src: fallbackImage
    }), /*#__PURE__*/React.createElement(IconPlayLarge, null)), /*#__PURE__*/React.createElement("div", {
      className: 'video__progress',
      style: {
        background: "linear-gradient(to right,  var(--main-color) ".concat(v.timestamp ? v.timestamp / (Duration / 1000) * 100 : 0, "%, #B9B9B9 0%)")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: 'video__content'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'video__header'
    }, /*#__PURE__*/React.createElement("span", {
      className: 'video__number'
    }, i + 1, "."), /*#__PURE__*/React.createElement("span", {
      className: 'video__time'
    }, toHHMMSS(Duration / 1000))), /*#__PURE__*/React.createElement("p", {
      className: 'video__title'
    }, title))));
  }))));
};
var PlaylistSeason = function PlaylistSeason(_ref2) {
  var items = _ref2.items,
    id = _ref2.id,
    onCallback = _ref2.onCallback,
    episodesText = _ref2.episodesText;
  return /*#__PURE__*/React.createElement("div", {
    className: 'playlist__season-wrapper'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'playlist__season-list'
  }, items.map(function (v, i) {
    var title = get(v, 'title.jss.value');
    var image = get(v, 'image.jss.value.src');
    var imageAlt = get(v, 'image.jss.value.alt');
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "playlist__season-item ".concat(title == id && 'current'),
      tabIndex: 0,
      onKeyPress: function onKeyPress(event) {
        if (event.key === "Enter" || event.key === "NumpadEnter" || event.which === 32) {
          event.preventDefault();
          event.stopPropagation();
          event.target.click();
        }
      },
      onClick: function onClick() {
        onCallback(title);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "season"
    }, /*#__PURE__*/React.createElement("div", {
      className: 'season__image-wrapper'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'season__image'
    }, /*#__PURE__*/React.createElement("img", {
      src: image,
      alt: imageAlt
    }))), /*#__PURE__*/React.createElement("div", {
      className: 'season__content'
    }, /*#__PURE__*/React.createElement("p", {
      className: 'season__subtitle'
    }, v.episode.length + " ".concat(episodesText)), /*#__PURE__*/React.createElement("p", {
      className: 'season__title'
    }, title))));
  })));
};
var Playlist = function Playlist(_ref3) {
  var styles = _ref3.styles,
    itemId = _ref3.itemId,
    _ref3$season = _ref3.season,
    season = _ref3$season === void 0 ? [] : _ref3$season,
    _ref3$episodesText = _ref3.episodesText,
    episodesText = _ref3$episodesText === void 0 ? 'episodes' : _ref3$episodesText;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setIsOpen = _React$useState2[1];
  var _React$useState3 = React.useState({
      episode: []
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    currentSeasonList = _React$useState4[0],
    setCurrentSeasonList = _React$useState4[1];
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    currentSeasonTitle = _React$useState6[0],
    setCurrentSeasonTitle = _React$useState6[1];
  React.useEffect(function () {
    var currentSeason = season.find(function () {
      var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        episode: []
      };
      return s.episode.find(function (s2) {
        return s2.id == itemId;
      });
    });
    setCurrentSeasonList(season.find(function (s) {
      return s.title.jss.value == currentSeasonTitle;
    }));
  }, [currentSeasonTitle]);
  React.useEffect(function () {
    var currentSeason = season.find(function () {
      var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        episode: []
      };
      return s.episode.find(function (s2) {
        return s2.id == itemId;
      });
    });
    setCurrentSeasonTitle(currentSeason && currentSeason.title.jss.value);
  }, [itemId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "playlist ".concat(playlistCss ? playlistCss : '', " ").concat(rtl ? playlistCssRtl : '', " ").concat(isOpen && 'isOpen', " ").concat(styles && styles)
  }, currentSeasonList && currentSeasonList.episode && currentSeasonList.episode.length && /*#__PURE__*/React.createElement("div", {
    className: 'playlist__item'
  }, season.length > 1 ? /*#__PURE__*/React.createElement("div", {
    className: 'playlist__title',
    tabIndex: 0,
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter" || event.key === "NumpadEnter" || event.which === 32) {
        event.preventDefault();
        event.stopPropagation();
        event.target.click();
      }
    },
    onClick: function onClick() {
      setIsOpen(!isOpen);
    }
  }, currentSeasonTitle, " ", /*#__PURE__*/React.createElement(ChevronDown, null)) : /*#__PURE__*/React.createElement("div", {
    className: 'playlist__title'
  }, currentSeasonTitle, " ", isOpen), /*#__PURE__*/React.createElement("div", {
    className: 'playlist__body'
  }, isOpen && /*#__PURE__*/React.createElement(PlaylistSeason, {
    episodesText: episodesText,
    items: season,
    id: currentSeasonTitle,
    onCallback: function onCallback(title) {
      setCurrentSeasonTitle(title);
      setIsOpen(false);
    }
  }), /*#__PURE__*/React.createElement(PlaylistList, {
    rtl: rtl,
    items: currentSeasonList
  }))));
};
export var playlistCss = "plb7ttm";
var playlistCssRtl = "p1b64yha";
export default Playlist;